import { render, staticRenderFns } from "./Metanav.vue?vue&type=template&id=bd6c80c2&"
import script from "./Metanav.vue?vue&type=script&lang=js&"
export * from "./Metanav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports